import {
  PuzzleTypeEnum,
  type PuzzleContent as PuzzleContentType,
} from '../../../../../shared/types'
import { parentMeta } from '../../type'
import styles from './PuzzleContent.module.scss'
import { TextPuzzle } from './types'
import usePuzzleContent from './usePuzzleContent'

interface PuzzleContentProps {
  parentMeta?: parentMeta
  content: PuzzleContentType
  filePath?: string
}

const PuzzleContent = (props: PuzzleContentProps) => {
  const { parentMeta, filePath, content } = props

  const { data, debugP2 } = usePuzzleContent()
  const { attempts, message, hints, newHintId, success } = data || {}

  const renderPuzzleContent = (props: PuzzleContentProps) => {
    switch (content.puzzleType) {
      case PuzzleTypeEnum.Text:
        return (
          <TextPuzzle
            {...props}
            id={content.id}
            type={content.type}
            puzzleType={content.puzzleType}
            question={content.question}
            parentMeta={parentMeta}
            filePath={filePath}
          />
        )
      case PuzzleTypeEnum.Grid:
      case PuzzleTypeEnum.Vector:
      default:
        return (
          <div className="status-message warning">
            Unsupported puzzle type: {content.type}
          </div>
        )
    }
  }

  return (
    <div className={styles.puzzleContentRoot}>
      {success && <div className={styles.solved}>{message || 'SOLVED!'}</div>}
      <h3>
        {debugP2 && <>Message: </>}
        {message}
      </h3>
      {debugP2 && <>Attempts: {attempts}</>}
      {hints && hints?.length > 0 && (
        <div className={styles.hints}>
          Hints:{' '}
          {hints?.map((hint) => (
            <div
              key={hint.id}
              className={newHintId === hint.id ? styles.newHint : ''}
            >
              {hint?.text}
            </div>
          ))}
        </div>
      )}
      {renderPuzzleContent(props)}
    </div>
  )
}

export default PuzzleContent
